import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    MDBBox,
    MDBDropdownMenu,
    MDBDropdownToggle,
    MDBDropdown,
} from "mdbreact";
import { RequestCard } from "pages/configuration/requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import {
    setFeatureRequest,
    setPersonalAreaActiveTab,
    setSidebarStatus,
} from "actions/user";

import {
    sortByDate,
    FROM_NEWER_TO_OLDER,
    FROM_OLDER_TO_NEWER,
} from "helpers/sortByDate";
import { sortContent } from "helpers/sortContent";

import { eventTrack } from "../../helpers/ga4Helper";
import { useHistory } from 'react-router';
import { getFeatureRequest } from 'api/featureRequests/getFeatureRequest';
import { createFeatureRequest } from 'api/featureRequests/createFeatureRequest';
import { useHttp } from 'hooks/useHttp';
import { getIdeas } from 'api/ideas/getIdeas';
import { useHttpWithCache } from 'hooks/useHtthWithCache';
import { onSelectedIdea, setIdeas } from 'actions/idea';
import SocialMediaBrand from 'components/SocialMediaBrand';
import PostListView from 'components/PostListView';
import KanbanBoard from 'components/KanbanBoard';
import Loading from 'components/ui-components/loading';
import NoItems from 'components/ui-components/no-items';
import Error from 'components/ui-components/Error';
import CreateIdeaModal from 'components/CreateIdeaModal';
import DeleteIdeaModal from 'components/DeleteIdeaModal/DeleteIdeaModal';
import { Maybe } from 'helpers/maybeFunctor';
import { useSearch } from 'hooks/useSearch';
import { Link } from 'react-router-dom';
import { setBrands } from 'actions/user';
import { getBrands } from 'api/brands/getBrands';
import { IDEA_KANBAN_STATUSES } from 'constants/kanbanStatuses';
import ContentFilterBar, { applyContentFilters } from 'components/ContentFilterBar';
import { computeFinalPermissions } from 'helpers/finalPermissions';

export const ACTIVE_TABS = {
    CARD_VIEW: "CARD_VIEW",
    LIST_VIEW: "LIST_VIEW",
    KANBAN_VIEW: "KANBAN_VIEW",
};

function IdeasPage({ brandId }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const search = useSearch();

    const usersPermissionRedux = useSelector((s) => s.user.userPermission);
    const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
    const allPermissionRedux = useSelector((s) => s.user.allPermission);
    const userInfoRedux = useSelector((s) => s.user.userInfo);
    const activeTabRedux = useSelector((s) => s.user.personalAreaActiveTab);
    const ideasRedux = useSelector((s) => s.ideas.ideas);
    const [ideas, setRenderingIdeas] = useState([...ideasRedux]);
    const [filteredIdeas, setFiltered] = useState([]);
    const [showFiltered, setShowFiltered] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [favouriteFilter, setFavouriteFilter] = useState(false);
    const [keyword, setKeyword] = useState("");

    const handleKeyword = (e) => {
        setKeyword(e.target.value);
        setTrigger(!trigger);
    };

    const FinalPermissions = computeFinalPermissions({
      userInfo: userInfoRedux,
      allPermission: allPermissionRedux,
      companyPermission: companyPermissionRedux,
      userPermission: usersPermissionRedux,
    });

    const { companyAdmin, superAdmin, company, name, lastName, email } =
        userInfoRedux;

    const [sortedToNewer, setSortedToNewer] = useState(true); // default newest-first
    const [searchValue, setSearchValue] = useState("");
    const [requestModal, setRequestModal] = useState(false);
    const [requestType, setRequestType] = useState("");
    const [featureRequests, setFeatureRequests] = useState([]);
    const [requestLoading, setRequestLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalName, setModalName] = useState("");
    // Idea about to be deleted — populated by the kanban / list / card
    // delete actions and consumed by DeleteIdeaModal below. We share
    // the same `modal` state machine the rest of the page already
    // uses (`'CreateIdea'`, `'DeleteIdea'`, ...).
    const [ideaToDelete, setIdeaToDelete] = useState(null);
    const [datecheck, setDatecheck] = useState(false);
    const [dueDate, setDueDate] = useState("");

    const handleOuterDateCheck = (e) => {
        setDatecheck(e.target.checked);
        if (!e.target.checked) {
            setDueDate("");
            setTrigger(!trigger);
        }
    };

    const handleDueDate = (e) => {
        setDueDate(e.target.value);
        setTrigger(!trigger);
    };

    const { request: getFeatureRequestAPI } = useHttp({
        requestCallback: getFeatureRequest,
        onLoad: (res) => {
            setFeatureRequests(res?.map((feature) => feature?.requestedFeature));
            dispatch(
                setFeatureRequest(res?.map((feature) => feature?.requestedFeature))
            );
        },
        onError: (res) => {
            console.log("getFeatureRequestAPI", { res });
        },
    });

    const requestAccess = async () => {
        try {
            setRequestLoading(true);
            const res = await createFeatureRequest(userInfoRedux.id, {
                companyId: userInfoRedux.company,
                permission: requestType,
                userId: userInfoRedux.id,
            });
            if (res) {
                setRequestLoading(false);
                dispatch(
                    setFeatureRequest(res.map((feature) => feature.requestedFeature))
                );
                setFeatureRequests(res.map((feature) => feature.requestedFeature));
            }
        } catch (e) {
            console.log(e);
        }
    };

    const {
        loading: ideaLoading,
        error: ideaError,
        request: getIdeasAPI,
    } = useHttpWithCache({
        requestCallback: () => getIdeas(),
        reduxSetter: (data) => {
            if (data.documents) {
                dispatch(setIdeas(data.documents));
            }
        },
        reduxReset: () => {
            dispatch(setIdeas([]));
        },
        reduxCash: {
            posts: ideasRedux,
        },
        allowToCash: false,
    });

    useEffect(() => {
        if (brandId) {
            const brandIdeas = ideasRedux.filter(idea => idea.brandId?._id === brandId || idea.brandId === brandId);
            setRenderingIdeas(brandIdeas);
        } else {
            // /all-ideas (no brandId) — show every idea the user can see.
            setRenderingIdeas(ideasRedux || []);
        }
    }, [brandId, ideasRedux]);

    const brandsRedux = useSelector((s) => s.user.brands);

    // Shared filter state used by the new ContentFilterBar.
    const [filters, setFilters] = useState({
        brandId: brandId || undefined,
        status: [],
        dateRange: null,
        keyword: ""
    });
    useEffect(() => {
        if (brandId && filters.brandId !== brandId) setFilters((f) => ({ ...f, brandId }));
        // eslint-disable-next-line
    }, [brandId]);
    const filtersActive = Boolean(
        filters.brandId || (filters.status && filters.status.length) || filters.dateRange || filters.keyword
    );
    // Apply ContentFilterBar filters first, THEN sort. Every view —
    // card / list / kanban — reads from this array, so the page's
    // sort toggle is now the single source of truth for card order.
    const filteredFinal = sortContent(
        filtersActive ? applyContentFilters(ideas || [], filters) : (ideas || []),
        sortedToNewer,
        { source: 'idea' }
    );

    const { request: requestBrands } = useHttpWithCache({
        requestCallback: () => getBrands(),
        reduxSetter: (data) => { dispatch(setBrands(data?.brands || data || [])); },
        reduxCash: { brands: brandsRedux },
        reduxReset: () => { dispatch(setBrands([])); },
        allowToCash: false,
    });

    useEffect(() => {
        getFeatureRequestAPI();
        getIdeasAPI();
        if (!brandsRedux || brandsRedux.length === 0) requestBrands();
    }, []);

    useEffect(() => {
        if (
            keyword ||
            searchValue ||
            favouriteFilter ||
            dueDate
        ) {
            let fBrands = Maybe.of(ideas).map((idea) => {
                // Sort the ideas based on the sorting order
                const sortedBrands = !sortedToNewer
                    ? sortByDate(idea, FROM_OLDER_TO_NEWER, 'createdAt')
                    : sortByDate(idea, FROM_NEWER_TO_OLDER, 'createdAt');
                let filteredData = sortedBrands;
                if (keyword) {
                    const titleBrands = search(sortedBrands, "title", keyword);
                    filteredData = titleBrands;
                } else if (searchValue) {
                    const searchedBrand = search(sortedBrands, "title", searchValue);
                    filteredData = searchedBrand;
                }

                if (dueDate) {
                    let dueDateFiltered = filteredData.filter((idea) => {
                        const selectedDate = new Date(dueDate);
                        const endDate = new Date(idea.createdAt);

                        return endDate <= selectedDate; // idea end date less than selected date
                    });
                    filteredData = dueDateFiltered;
                }

                if (favouriteFilter) {
                    let favouriteIdeas = filteredData.filter(idea => {
                        return idea.favourite;
                    });
                    filteredData = favouriteIdeas;
                }

                return filteredData;
            });
            setFiltered(fBrands.value || []);
            setShowFiltered(true);
        } else {
            setShowFiltered(false);
            setFiltered(ideas);
        }
    }, [trigger, searchValue, favouriteFilter]);

    return (
        <div className='idea-page'>
            <div className="inner-header-position">
                <div className="inner-header-position">
                    <div className="custom-container d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center"
                        >
                            <span
                                style={{
                                    alignItems: "center",
                                    display: "flex",
                                    cursor: "pointer",
                                }}
                                onClick={() => dispatch(setSidebarStatus(true))}
                            >
                                <div
                                    className="cursor-pointer"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="7"
                                        height="10"
                                        viewBox="0 0 7 10"
                                        fill="none"
                                    >
                                        <path
                                            d="M6.84102 8.825L3.02435 5L6.84102 1.175L5.66602 0L0.666016 5L5.66602 10L6.84102 8.825Z"
                                            fill="#9E9E9E"
                                        />
                                    </svg>
                                </div>
                                <p className="my-heading f-14 ml-3 mr-3">Side Menu</p>
                            </span>
                            {brandId && (<>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="7"
                                height="10"
                                viewBox="0 0 7 10"
                                fill="none"
                            >
                                <path
                                    d="M6.84102 8.825L3.02435 5L6.84102 1.175L5.66602 0L0.666016 5L5.66602 10L6.84102 8.825Z"
                                    fill="#9E9E9E"
                                />
                            </svg>
                            <p className="my-heading f-14 ml-3 mr-3">
                                {" "}
                                <Link className="link-menu" to="personal-area">All Brands</Link>
                            </p>
                            </>)}
                        </div>

                        <div
                            className="projActionButtons d-flex flex-wrap"
                            style={{ maxWidth: "100vw" }}
                        >
                            <input
                                type="text"
                                className="search-bar"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                placeholder="Search"
                                disabled={ideaLoading}
                            />
                            <div className="vr mx-3"></div>
                            <div className="btn-tool-group">
                                {
                                    (userInfoRedux?.superAdmin ||
                                        userInfoRedux?.companyAdmin) && (
                                        <>
                                            <button
                                                onClick={() => {
                                                    if (
                                                        FinalPermissions?.includes(
                                                            ALL_PERMISSIONS.BRAND_VIEW
                                                        )
                                                    ) {
                                                        history.push(`/admin/brands-settings`);
                                                    } else if (
                                                        FinalPermissions?.includes(
                                                            ALL_PERMISSIONS.STATUS_VIEW
                                                        )
                                                    ) {
                                                        history.push(`/admin/statuses`);
                                                    } else {
                                                        history.push(`/admin/user-permissions`);
                                                    }
                                                    eventTrack(
                                                        "Navigate-Admin-Section-Action",
                                                        "Navigate-Admin-Section",
                                                        name,
                                                        "+1",
                                                        false,
                                                        "+1"
                                                    );
                                                }}
                                                className="bg-bid px-3 mr-0"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="19"
                                                    viewBox="0 0 14 19"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M0.333984 18.3335C0.333984 14.6516 3.31875 11.6668 7.00065 11.6668C10.6826 11.6668 13.6673 14.6516 13.6673 18.3335H0.333984ZM7.00065 10.8335C4.23815 10.8335 2.00065 8.596 2.00065 5.8335C2.00065 3.071 4.23815 0.833496 7.00065 0.833496C9.76315 0.833496 12.0007 3.071 12.0007 5.8335C12.0007 8.596 9.76315 10.8335 7.00065 10.8335Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                                Admin
                                            </button>
                                            <div className="vr mx-3"></div>
                                        </>
                                    )
                                }

                                <div className="d-flex align-items-center">
                                    <div className="btn-tool-group">
                                        <button
                                            onClick={() => setModal("CreateIdea")}
                                            className="refresh-btn bg-bid text-white mr-0"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M12 4v16m8-8H4"
                                                />
                                            </svg>
                                            New Idea
                                        </button>
                                        <div className="vr mx-3"></div>

                                        <button
                                            onClick={getIdeasAPI}
                                            disabled={ideaLoading}
                                            className="refresh-btn bg-bid text-white mr-2"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                                />
                                            </svg>
                                            Refresh
                                        </button>
                                    </div>
                                </div>

                                <button
                                    onClick={() => setSortedToNewer(!sortedToNewer)}
                                    disabled={ideaLoading}
                                    className="px-3 bg-white text-bid shadow-hover"
                                    title="Sort"
                                >
                                    {!sortedToNewer ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="15"
                                            viewBox="0 0 18 15"
                                            fill="none"
                                        >
                                            <path
                                                d="M14.6667 0.833252V10.8333H17.1667L13.8333 14.9999L10.5 10.8333H13V0.833252H14.6667ZM8 12.4999V14.1666H0.5V12.4999H8ZM9.66667 6.66659V8.33325H0.5V6.66659H9.66667ZM9.66667 0.833252V2.49992H0.5V0.833252H9.66667Z"
                                                fill="#3A5765"
                                            />
                                            <path
                                                d="M14.6667 0.833252V10.8333H17.1667L13.8333 14.9999L10.5 10.8333H13V0.833252H14.6667ZM8 12.4999V14.1666H0.5V12.4999H8ZM9.66667 6.66659V8.33325H0.5V6.66659H9.66667ZM9.66667 0.833252V2.49992H0.5V0.833252H9.66667Z"
                                                fill="black"
                                                fillOpacity="0.2"
                                            />
                                        </svg>
                                    ) : (
                                        <div className="upsideDown-svg">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="15"
                                                viewBox="0 0 18 15"
                                                fill="none"
                                            >
                                                <path
                                                    d="M14.6667 0.833252V10.8333H17.1667L13.8333 14.9999L10.5 10.8333H13V0.833252H14.6667ZM8 12.4999V14.1666H0.5V12.4999H8ZM9.66667 6.66659V8.33325H0.5V6.66659H9.66667ZM9.66667 0.833252V2.49992H0.5V0.833252H9.66667Z"
                                                    fill="#3A5765"
                                                />
                                                <path
                                                    d="M14.6667 0.833252V10.8333H17.1667L13.8333 14.9999L10.5 10.8333H13V0.833252H14.6667ZM8 12.4999V14.1666H0.5V12.4999H8ZM9.66667 6.66659V8.33325H0.5V6.66659H9.66667ZM9.66667 0.833252V2.49992H0.5V0.833252H9.66667Z"
                                                    fill="black"
                                                    fillOpacity="0.2"
                                                />
                                            </svg>
                                        </div>
                                    )}
                                    Sort
                                </button>

                                <div className="vr mx-2"></div>

                                <div className="d-flex view-switch-container">
                                    <div
                                        onClick={() => {
                                            dispatch(setPersonalAreaActiveTab(ACTIVE_TABS.CARD_VIEW));
                                            eventTrack(
                                                "View-Brand-CardView-Action",
                                                "View-Brand-CardView",
                                                userInfoRedux?.name,
                                                "+1",
                                                false,
                                                "+1"
                                            );
                                        }}
                                        className={
                                            activeTabRedux === ACTIVE_TABS.CARD_VIEW ? "active" : null
                                        }
                                        title="Card view"
                                    >
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M16 2H15V1C15 0.447715 14.5523 0 14 0C13.4477 0 13 0.447715 13 1V2H7V1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V2H4C2.34315 2 1 3.34315 1 5V16C1 17.6569 2.34315 19 4 19H16C17.6569 19 19 17.6569 19 16V5C19 3.34315 17.6569 2 16 2ZM17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V8H17V16ZM17 6H3V5C3 4.44772 3.44772 4 4 4H5V5C5 5.55228 5.44772 6 6 6C6.55228 6 7 5.55228 7 5V4H13V5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5V4H16C16.5523 4 17 4.44772 17 5V6Z"
                                                fill="#C0C0C0"
                                            />
                                        </svg>
                                    </div>

                                    <div
                                        onClick={() => {
                                            dispatch(setPersonalAreaActiveTab(ACTIVE_TABS.LIST_VIEW));
                                            eventTrack(
                                                "View-Brand-ListView-Action",
                                                "View-Brand-ListView",
                                                userInfoRedux?.name,
                                                "+1",
                                                false,
                                                "+1"
                                            );
                                        }}
                                        className={
                                            activeTabRedux === ACTIVE_TABS.LIST_VIEW ? "active" : null
                                        }
                                        title="List view"
                                    >
                                        <svg
                                            width="21"
                                            height="16"
                                            viewBox="0 0 21 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M7.97384 14.0002H18.9738V11.3252H7.97384V14.0002ZM2.97384 4.67518H5.97384V2.0002H2.97384V4.67518ZM2.97384 9.35017H5.97384V6.67518H2.97384V9.35017ZM2.97384 14.0002H5.97384V11.3252H2.97384V14.0002ZM7.97384 9.35017H18.9738V6.67518H7.97384V9.35017ZM7.97384 4.67518H18.9738V2.0002H7.97384V4.67518ZM2.97384 16.0002C2.71071 16.0041 2.44957 15.954 2.20655 15.853C1.96352 15.7521 1.74377 15.6024 1.56084 15.4132C1.37165 15.2303 1.22196 15.0105 1.12101 14.7675C1.02005 14.5244 0.969962 14.2633 0.973842 14.0002V2.0002C0.970228 1.73716 1.02053 1.4762 1.12166 1.23335C1.22279 0.990503 1.3726 0.770934 1.56184 0.588208C1.74456 0.398965 1.96412 0.249151 2.20697 0.148023C2.44981 0.0468939 2.71081 -0.00341862 2.97384 0.000195533H18.9738C19.237 -0.0035558 19.4982 0.0467067 19.7413 0.14784C19.9843 0.248972 20.204 0.398841 20.3868 0.588208C20.5759 0.771019 20.7255 0.990629 20.8265 1.23347C20.9274 1.47631 20.9776 1.73723 20.9738 2.0002V14.0002C20.9775 14.2632 20.9272 14.5242 20.826 14.767C20.7249 15.0099 20.5751 15.2295 20.3858 15.4122C20.2031 15.6014 19.9836 15.7512 19.7407 15.8524C19.4979 15.9535 19.2369 16.0038 18.9738 16.0002H2.97384Z"
                                                fill="#C0C0C0"
                                            />
                                        </svg>
                                    </div>
                                    {FinalPermissions?.includes(ALL_PERMISSIONS.KANBAN_VIEW) ? (
                                        <div
                                            className={
                                                activeTabRedux === ACTIVE_TABS.KANBAN_VIEW
                                                    ? "active"
                                                    : null
                                            }
                                            onClick={() => {
                                                dispatch(
                                                    setPersonalAreaActiveTab(ACTIVE_TABS.KANBAN_VIEW)
                                                );
                                                eventTrack(
                                                    "View-Brand-KanbanView-Action",
                                                    "View-Brand-KanbanView",
                                                    userInfoRedux?.name,
                                                    "+1",
                                                    false,
                                                    "+1"
                                                );
                                            }}
                                            title="Kanban view"
                                        >
                                            <svg
                                                width="21"
                                                height="16"
                                                viewBox="0 0 21 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.97384 14H6.97384V1.99995H2.97384V14ZM8.97384 14H12.9738V1.99995H8.97384V14ZM14.9738 14H18.9738V1.99995H14.9738V14ZM2.97384 16C2.71071 16.0038 2.44957 15.9538 2.20655 15.8528C1.96352 15.7518 1.74377 15.6022 1.56084 15.413C1.37165 15.23 1.22196 15.0102 1.12101 14.7672C1.02005 14.5242 0.969962 14.2631 0.973842 14V1.99995C0.970099 1.73699 1.02025 1.47607 1.1212 1.23323C1.22216 0.990385 1.37178 0.770775 1.56084 0.587964C1.74368 0.398597 1.9634 0.248728 2.20643 0.147595C2.44946 0.0464626 2.71064 -0.00379994 2.97384 -4.86073e-05H18.9738C19.237 -0.00379994 19.4982 0.0464626 19.7413 0.147595C19.9843 0.248728 20.204 0.398597 20.3868 0.587964C20.5759 0.770775 20.7255 0.990385 20.8265 1.23323C20.9274 1.47607 20.9776 1.73699 20.9738 1.99995V14C20.9777 14.2631 20.9276 14.5242 20.8267 14.7672C20.7257 15.0102 20.576 15.23 20.3868 15.413C20.2039 15.6022 19.9842 15.7518 19.7411 15.8528C19.4981 15.9538 19.237 16.0038 18.9738 16H2.97384Z"
                                                    fill="#C0C0C0"
                                                />
                                            </svg>
                                        </div>
                                    ) : (
                                        <div
                                            onClick={() => {
                                                setRequestType(ALL_PERMISSIONS.KANBAN_VIEW);
                                                setRequestModal(true);
                                            }}
                                            className={
                                                activeTabRedux === ACTIVE_TABS.KANBAN_VIEW
                                                    ? "active"
                                                    : null
                                            }
                                            title="Kanban view"
                                        >
                                            <svg
                                                width="21"
                                                height="16"
                                                viewBox="0 0 21 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.97384 14H6.97384V1.99995H2.97384V14ZM8.97384 14H12.9738V1.99995H8.97384V14ZM14.9738 14H18.9738V1.99995H14.9738V14ZM2.97384 16C2.71071 16.0038 2.44957 15.9538 2.20655 15.8528C1.96352 15.7518 1.74377 15.6022 1.56084 15.413C1.37165 15.23 1.22196 15.0102 1.12101 14.7672C1.02005 14.5242 0.969962 14.2631 0.973842 14V1.99995C0.970099 1.73699 1.02025 1.47607 1.1212 1.23323C1.22216 0.990385 1.37178 0.770775 1.56084 0.587964C1.74368 0.398597 1.9634 0.248728 2.20643 0.147595C2.44946 0.0464626 2.71064 -0.00379994 2.97384 -4.86073e-05H18.9738C19.237 -0.00379994 19.4982 0.0464626 19.7413 0.147595C19.9843 0.248728 20.204 0.398597 20.3868 0.587964C20.5759 0.770775 20.7255 0.990385 20.8265 1.23323C20.9274 1.47607 20.9776 1.73699 20.9738 1.99995V14C20.9777 14.2631 20.9276 14.5242 20.8267 14.7672C20.7257 15.0102 20.576 15.23 20.3868 15.413C20.2039 15.6022 19.9842 15.7518 19.7411 15.8528C19.4981 15.9538 19.237 16.0038 18.9738 16H2.97384Z"
                                                    fill="#C0C0C0"
                                                />
                                            </svg>
                                        </div>
                                    )}
                                </div>
                                <div className="vr mx-2"></div>
                                <div className="head-filter-icon">
                                    <MDBDropdown>
                                        <MDBDropdownToggle
                                            style={{ backgroundColor: "white" }}
                                            color="link"
                                            title="Filters"
                                        >
                                            <svg
                                                width="17"
                                                height="16"
                                                viewBox="0 0 17 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M7.97635 16.0002C7.8442 16.0036 7.71277 15.9798 7.59015 15.9305C7.46752 15.8811 7.3563 15.8072 7.26335 15.7132C7.16932 15.6203 7.09534 15.509 7.04597 15.3864C6.99661 15.2638 6.97291 15.1323 6.97635 15.0002V9.00018L1.17635 1.60015C1.05613 1.45573 0.981356 1.27901 0.961426 1.09216C0.941495 0.905308 0.977304 0.716699 1.06435 0.550165C1.14163 0.376041 1.27058 0.229907 1.43372 0.131525C1.59685 0.0331435 1.78628 -0.0127164 1.97635 0.000177374H15.9763C16.1664 -0.0127164 16.3559 0.0331435 16.519 0.131525C16.6821 0.229907 16.8111 0.376041 16.8884 0.550165C16.9754 0.716699 17.0112 0.905308 16.9913 1.09216C16.9713 1.27901 16.8966 1.45573 16.7764 1.60015L10.9763 9.00018V15.0002C10.9797 15.1324 10.9558 15.2639 10.9063 15.3865C10.8567 15.5092 10.7826 15.6204 10.6884 15.7132C10.5955 15.8071 10.4845 15.8809 10.362 15.9303C10.2396 15.9796 10.1083 16.0034 9.97635 16.0002H7.97635ZM8.97635 8.30017L13.9263 2.00018H4.02635L8.97635 8.30017Z"
                                                    fill="#455E6C"
                                                />
                                            </svg>
                                            <p className="filter-indicator">
                                                {(showFiltered ? filteredIdeas : ideas).length}
                                            </p>
                                        </MDBDropdownToggle>
                                        <MDBDropdownMenu
                                            responsive="lg-end"
                                            right
                                            style={{ width: "200px" }}
                                        >
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <div className="mb-2">
                                                        <input
                                                            value={keyword}
                                                            onChange={handleKeyword}
                                                            type="text"
                                                            className="form-control filter-input"
                                                            placeholder="Keyword"
                                                        />
                                                    </div>

                                                    {/* Favourite */}
                                                    <label className="form-check">
                                                        <input
                                                            value={favouriteFilter}
                                                            onChange={() => setFavouriteFilter(!favouriteFilter)}
                                                            className="form-check-input small-squared-checkbox"
                                                            type="checkbox"
                                                        />{" "}
                                                        Show Favourite
                                                    </label>

                                                    {/* Creation Date */}
                                                    <label className="form-check">
                                                        <input
                                                            value={datecheck}
                                                            onChange={handleOuterDateCheck}
                                                            className="form-check-input small-squared-checkbox"
                                                            type="checkbox"
                                                        />{" "}
                                                        Creation Date
                                                    </label>
                                                    {datecheck && (
                                                        <div className="ml-3 mt-0">
                                                            <input
                                                                onChange={handleDueDate}
                                                                type="date"
                                                                className="date-picker-input"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </MDBDropdownMenu>
                                    </MDBDropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {ideaLoading && <Loading color="black" text="Loading..." />}

            <div className="historyCards pt-2">
                <div className="d-flex align-items-center brand-admin-header ">
                    {brandId ? "" : "All Ideas"}
                </div>
                <ContentFilterBar
                    filters={filters}
                    setFilters={setFilters}
                    brands={brandsRedux || []}
                    statusOptions={IDEA_KANBAN_STATUSES.map((s) => ({ value: s.key, label: s.name }))}
                    resultCount={filteredFinal.length}
                    totalCount={(ideas || []).length}
                />
                <MDBBox className="pt-2">
                    {/* {maybeBrandPosts} */}
                    {ideaError ? <Error /> : null}
                    {ideas.length === 0 ? (
                        <NoItems text="There are no Ideas" />
                    ) : (
                        (activeTabRedux === ACTIVE_TABS.CARD_VIEW && (
                            <SocialMediaBrand
                                onEdit={(idea) => {
                                    setModal('CreateIdea');
                                    dispatch(onSelectedIdea(idea));
                                }}
                                onDelete={(idea) => { setIdeaToDelete(idea); setModal('DeleteIdea'); }}
                                posts={filteredFinal}
                                source={"idea"}
                            />
                        )) ||
                        (activeTabRedux === ACTIVE_TABS.LIST_VIEW && (
                            <PostListView
                                onEdit={(idea) => { setModal('CreateIdea'); dispatch(onSelectedIdea(idea)) }}
                                onDelete={(idea) => { setIdeaToDelete(idea); setModal('DeleteIdea'); }}
                                posts={filteredFinal}
                                source={"idea"}
                            />
                        )) || (activeTabRedux === ACTIVE_TABS.KANBAN_VIEW && (
                            <KanbanBoard
                                posts={filteredFinal}
                                statuses={IDEA_KANBAN_STATUSES}
                                isAdmin={companyAdmin || superAdmin}
                                // KanbanCard's handleDelete sets the
                                // "brandToDelete" + opens "DeleteModal" —
                                // we adapt: stash the idea, then steer
                                // the page's `modal` state to DeleteIdea
                                // so the right modal opens. The previous
                                // wiring used a separate `modalName`
                                // state nothing rendered against, so
                                // clicking Delete in the kanban silently
                                // did nothing.
                                setModal={(name) => {
                                    if (name === 'DeleteModal') setModal('DeleteIdea');
                                    else setModalName(name);
                                }}
                                onEdit={(idea) => { setModal('CreateIdea'); dispatch(onSelectedIdea(idea)) }}
                                setBrandToDelete={setIdeaToDelete}
                                setBrandToUpdate={() => { }}
                                setBrandListToEdit={() => { }}
                                // users={usersMap}
                                source={"idea"}
                            />
                        ))
                    )}
                </MDBBox>
                <CreateIdeaModal
                    isOpen={modal === 'CreateIdea'}
                    toggleModal={() => setModal('')}
                />
                <DeleteIdeaModal
                    isOpen={modal === 'DeleteIdea'}
                    toggle={() => setModal('')}
                    itemToDelete={ideaToDelete?._id}
                />
                <Modal
                    title={
                        userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
                    }
                    open={requestModal}
                    footer={null}
                    onCancel={() => setRequestModal(false)}
                >
                    <RequestCard
                        status={featureRequests?.includes(requestType)}
                        loading={requestLoading}
                        icon={
                            featureRequests?.includes(requestType) ? (
                                <ClockCircleOutlined style={{ color: "black" }} />
                            ) : (
                                <InfoCircleOutlined style={{ color: "black" }} />
                            )
                        }
                        title={
                            featureRequests?.includes(requestType)
                                ? `Request Already Sent`
                                : `Oops, looks like you need to ${userInfoRedux?.companyAdmin
                                    ? `Acquire License`
                                    : `Request Access`
                                }`
                        }
                        description={
                            featureRequests?.includes(requestType)
                                ? `Please reach out to your brand Admin`
                                : `Elevate your experience with exclusive futures, early releases, and premium features.`
                        }
                        buttonText={
                            userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
                        }
                        buttonHandler={() => requestAccess()}
                    />
                </Modal>
            </div>
        </div>
    )
}

export default IdeasPage;
